// ABOUTME: Loading spinner component with size variants.
// ABOUTME: Uses Tailwind CSS animations with warm teal theme colors.

import { type HTMLAttributes } from 'react';

interface LoadingSpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-10 h-10 border-3',
};

export function LoadingSpinner({ size = 'md', className = '', ...props }: LoadingSpinnerProps) {
  return (
    <div
      className={`${sizeClasses[size]} border-primary-200 border-t-primary-500 rounded-full animate-spin ${className}`}
      role="status"
      aria-label="Loading"
      {...props}
    />
  );
}
